module.exports = __webpack_public_path__ + "img/LInvoice.21ad3eda.svg";